import { Controller } from 'stimulus'
import axios from 'axios'

export default class extends Controller {
    static targets = ["gateway", "processor"]
    populateGateways(){
        let processorId = this.processorTarget.value
        this.gatewayTarget.setAttribute('disabled', 'disabled');

        axios.get('/gateways?processor_id=' + processorId)
          .then((resp) => {
            document.getElementById('gateway-select').outerHTML = resp.data
            this._prevProcessor = processorId
            this.gatewayTarget.removeAttribute('disabled')
          })
          .catch(function(e){
            console.log(e)
          })
    }
  
    connect() {
        this.populateGateways()
    }

    focus(event) {
        this._prevProcessor = event.currentTarget.value
    }

    change(event) {
        this.populateGateways()
    }
}
